/**
 * "Refresh all" on the account page.
 *
 * The page header owns one button; the panels own the fetches. Panels report
 * busy/idle back up so the button spins and stays disabled for exactly as long as
 * work is actually in flight — rather than guessing with a timer.
 */

/** $rootScope.$broadcast — every account panel reloads. */
export const AccountRefreshAllEvent = 'gpAccount:refreshAll';

/** $scope.$emit from a panel — bubbles to the account controller. */
export const AccountPanelBusyEvent = 'gpAccount:panelBusy';

export interface AccountPanelBusyPayload {
    /** Stable per panel, so repeated reports replace rather than accumulate. */
    panel: string;
    busy: boolean;
}

/**
 * Which panels are currently fetching. Keyed rather than counted: a panel that
 * reports busy twice (focus refresh landing on top of a Refresh all) must not leave
 * the button stuck once one of them finishes.
 */
export function applyPanelBusy(busyPanels: Record<string, boolean>, payload: AccountPanelBusyPayload): Record<string, boolean> {
    const next = { ...busyPanels };
    if (payload.busy) {
        next[payload.panel] = true;
    } else {
        delete next[payload.panel];
    }
    return next;
}

export function anyPanelBusy(busyPanels: Record<string, boolean>): boolean {
    return Object.keys(busyPanels).length > 0;
}
